import ClosedCaptions from 'components/ClosedCaptions'
import usePrevious from 'hooks/usePrevious'
import React from 'react'
import { useRef } from 'react'
import { useCallback } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { gotCaptions } from 'actions/stream'

const Captions = () => {
  const dispatch = useDispatch()
  const [transcriptArr, setTranscriptArr] = useState([])
  const [captionWebSocket, setCaptionWebSocket] = useState(null)
  const captionShow = useSelector(state => state.stream.captions)
  const recivedCaptions = useSelector(state => state.stream.gotCaptions)
  const [captionText, setCaptionText] = useState('')
  const videoControlled = useSelector(
    state =>
      state.stream.cloudinaryVideoControlled &&
      state.stream.egLiveVideoControlled
  )
  const event = useSelector(state => state.event.event)
  const hasLiveVideo =
    event.live_url_data && event.live_url_data.find(x => x.live_now)
  const liveVideo =
    // videoControlled here is for weird mobile issue
    videoControlled && hasLiveVideo
  const streamId = liveVideo && liveVideo.id
  const streamIdRef = useRef()
  streamIdRef.current = streamId
  // const prevStreamId = usePrevious(streamId)
  //import new redux id to keep track of loader button
  const setNewCaptions = useCallback(newArr => {
    let newMessage = ''
    newArr = [...newArr.reverse()].filter((x, i) => {
      if (newMessage.length <= 100) {
        newMessage = x.message + ' ' + newMessage
        return true
      } else {
        return false
      }
    })
    setCaptionText(newMessage)
    return [...newArr.reverse()]
  }, [])

  useEffect(() => {
    //TODO: set a redux variable to true ONLY when it is false and newMessage is ''
    //NOTE: this should only be called once
    if (captionText !== '' && !recivedCaptions) {
      dispatch(gotCaptions(true))
    }
  }, [recivedCaptions, captionText])

  // effect for switching streamId when captions are on
  useEffect(() => {
    if (
      captionWebSocket &&
      captionWebSocket.readyState === captionWebSocket.OPEN
    ) {
      //TODO: reset setCaptionText here whenever we change the stream id
      setCaptionText('')
      dispatch(gotCaptions(false))
      captionWebSocket.send(JSON.stringify({ stream_id: streamId }))
    }
  }, [streamId, captionWebSocket])

  const connectWebSocket = (tries = 0) => {
    if (captionShow) {
      const newWebSocket = new WebSocket(
        process.env.REACT_APP_CAPTIONS_EDGE_URL
      )
      newWebSocket.onmessage = function(event) {
        if (event.data === 'ping') {
          return newWebSocket.send('pong')
        }
        let msgdata = JSON.parse(event.data)

        if (msgdata.error) {
          return console.log(msgdata)
        }

        if (msgdata.final) {
          setTimeout(() => {
            setTranscriptArr(lastState => {
              const callback = x => x.id !== msgdata.id
              const newState = lastState.filter(callback)
              return setNewCaptions(newState, recivedCaptions)
            })
          }, 3000)
        }
        setTranscriptArr(lastState => {
          let newArr = lastState
          if (newArr.length === 0) {
            newArr.push(msgdata)
          } else if (newArr[newArr.length - 1].id === msgdata.id) {
            newArr.splice(newArr.length - 1, 1)
            newArr.push(msgdata)
          } else {
            newArr.push(msgdata)
          }
          return setNewCaptions(newArr, recivedCaptions)
        })
      }
      newWebSocket.onopen = () => {
        newWebSocket.send(JSON.stringify({ stream_id: streamIdRef.current }))
      }
      newWebSocket.onclose = () => {
        setTimeout(() => {
          connectWebSocket(tries + 1)
        }, tries * 100)
      }
      setCaptionWebSocket(newWebSocket)
    } else {
      console.log('not creating becuase captions turned off')
    }
  }

  // effect for creating or destroying websocket
  useEffect(() => {
    const captionsOn = captionShow && liveVideo
    // connect websocket when user has captions on and there is a video and there is not already an open connection
    if (
      captionsOn &&
      (!captionWebSocket ||
        (captionWebSocket &&
          captionWebSocket.readyState !== captionWebSocket.OPEN))
    ) {
      connectWebSocket()
      // disconnect if there is still a websocket connected and no video to show or the user turned off captions
    } else if (!captionsOn && captionWebSocket) {
      captionWebSocket.onclose = () => ''
      captionWebSocket.close()
      setCaptionText('')
      setTranscriptArr([])
      setCaptionWebSocket(null)
      dispatch(gotCaptions(false))
    }
  }, [captionShow, liveVideo, recivedCaptions])
  // console.log(prevStreamId, streamId, captionText)
  return <ClosedCaptions text={captionText} />
}

export default Captions



// WEBPACK FOOTER //
// ./src/components/LiveVideo/Captions/index.jsx